import React from 'react';
import propTypes from 'prop-types';
import { Icon } from '@tcc/crate';

const baseString = 'vra-value-with-unit';

const ValueWithUnit = ({
  unit,
  value,
  editable,
  onEdit
}) => {
  return (
    <span>
      {editable ? (
        <button 
          className={`${baseString}__value-btn`} 
          data-test-id="vra-value-with-unit--clickable"
          onClick={onEdit}
        >
          <Icon glyph={Icon.set.PENCIL} /> <span>{value}</span>
        </button>
      ) : (
        <span className={`${baseString}__value`}>{value}</span>
      )}
      <span className={`${baseString}__unit`}>{unit}</span>
    </span>
  );
};

ValueWithUnit.propTypes = {
  editable: propTypes.bool,
  onEdit: propTypes.func,
  unit: propTypes.string.isRequired,
  value: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired
};

export default ValueWithUnit;